module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/buttom_checkbox.972acce7.svg";